/* eslint-disable */

import {
  Avatar,
  Badge,
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Icon,
  Stack,
  Progress,
  Box,
  FormControl,
  FormLabel,
  Select,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  useBreakpointValue,
  ResponsiveValue,
} from '@chakra-ui/react';
// Custom components
import { MdChevronRight, MdChevronLeft, MdMoreHoriz } from 'react-icons/md';
import * as React from 'react';
// Assets
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

import {
  createColumnHelper,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
  OnChangeFn,
} from '@tanstack/react-table';
import {
  PlanTypeEnum,
  UserInterface,
  StatusTypeEnum,
} from '../../../../../../Redux/User/types';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPageNo,
  selectPageSize,
  selectAdd,
  selectLoading,
  selectTotalRow,
  selectSearch,
  selectDisableAccountModal,
  selectDeleteAccountModal,
  selectSortColumn,
  selectSortDir,
} from '../../../../../../Redux/User/selector';
import { actions } from '../../../../../../Redux/User/slice';
import Add from 'components/UserList/Add';

import { AddIcon } from '@chakra-ui/icons';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import ConfirmModal from 'components/UserList/ConfirmModal';
import { path } from 'utils/Api';
import dateFormat from 'components/hooks/dateFormat';
import moment from 'moment';

export default function SearchTableOrders(props: { data: any }) {
  const { data } = props;
  React.useEffect(() => {
    table.getHeaderGroups();
    getPaginationRowModel();
    return () => {};
  }, [data]);

  const pagesize = useSelector(selectPageSize);
  const loading = useSelector(selectLoading);
  const totalCount = useSelector(selectTotalRow);
  const disableModal = useSelector(selectDisableAccountModal);
  const deleteModal = useSelector(selectDeleteAccountModal);
  const SortColumn = useSelector(selectSortColumn);
  const SortDir = useSelector(selectSortDir);
  React.useEffect(() => {
    dispatch(actions.doGetList());
    return () => {};
  }, [SortDir, SortColumn]);
  const [selectedId, setSelectedId] = React.useState('');
  const [activeStatus, setActiveStatus] = React.useState<number>(0);
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const add = useSelector(selectAdd);
  React.useEffect(() => {
    handleClose();
    table.getHeaderGroups();
    getPaginationRowModel();
    return () => {};
  }, []);

  const handleClose = () => {
    setGlobalFilter('');
    dispatch(actions.toggleAdd(false));
    dispatch(actions.clearFrom());
    setSelectedId('');
  };
  const handleCloseDisableModal = () => {
    dispatch(actions.toggleDisableAccountModal(false));
    setSelectedId('');
  };
  const handleDisable = () => {
    dispatch(
      actions.doDisableAccount({
        id: selectedId,
        status: activeStatus == 1 ? 2 : 1,
        callback: () => {
          dispatch(actions.toggleDisableAccountModal(false));
          dispatch(actions.doGetList());
        },
      }),
    );
  };
  const handleCloseDeleteModal = () => {
    dispatch(actions.toggleDeleteAccountModal(false));
    setSelectedId('');
  };
  const handleDelete = () => {
    dispatch(
      actions.doDelete({
        id: selectedId,
        callback: () => {
          dispatch(actions.toggleDeleteAccountModal(false));
          dispatch(actions.doGetList());
        },
      }),
    );
  };

  React.useEffect(() => {
    dispatch(actions.setPageNo(1));
    dispatch(actions.setPageSize(10));
    dispatch(actions.setSearch(''));
    return () => {};
  }, []);
  const handleEdit = (id: string) => {
    setSelectedId(id);
    dispatch(actions.doGetEdit(id));
    dispatch(actions.toggleAdd(true));
  };

  const textColor = useColorModeValue('#D2D3E0', '#D2D3E0');
  const borderColor = useColorModeValue('#2C2D3C', '#2C2D3C');
  const brandColor = useColorModeValue('brand.500', 'brand.400');

  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = React.useState('');
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Name',

      cell: (info: any) => {
        return (
          <Stack direction="row" align="center" justify="start">
            <Avatar
              size="sm"
              name={info.row.original?.name}
              src={`${
                info.row.original?.profilePic?.includes('googleusercontent.com')
                  ? `${info.row.original.profilePic}`
                  : info.row.original.profilePic
                  ? `${path()}${info.row.original.profilePic}`
                  : `${info.row.original.profilePic}`
              }`}
              sx={avatarStyle}
            />
            <Text marginLeft={2}>
              {info.getValue()?.length > 40
                ? info.getValue()?.slice(0, 40)
                : info.getValue()}
            </Text>
          </Stack>
        );
      },
    }),
    columnHelper.accessor('email', {
      id: 'email',
      enableSorting: true,
      header: 'Email Address',
      sortDescFirst: false,
      sortingFn: 'text',
    }),

    columnHelper.accessor('totalProject', {
      id: 'totalProject',
      header: 'Total Projects',
    }),
    columnHelper.accessor('planName', {
      id: 'planName',
      header: 'Plan',
    }),
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: 'Registered Date',
      cell: (info: any) => (
        <Text>{moment(info.getValue()).format('YYYY/MM/DD')}</Text>
      ),
    }),
    columnHelper.accessor('isActive', {
      id: 'isActive',
      header: 'Status',
      cell: (info: any) => (
        <Badge
          variant="outline"
          textTransform="capitalize"
          color={
            info.getValue() === StatusTypeEnum.ACTIVE ? '#F3A79F' : '#FF3B2E'
          }
          boxShadow={`inset 0 0 0 1px ${
            info.getValue() === StatusTypeEnum.ACTIVE ? '#F3A79F' : '#FF3B2E'
          }`}
        >
          {info.getValue() == StatusTypeEnum.ACTIVE ? 'Active' : 'Disabled'}
        </Badge>
      ),
    }),
    columnHelper.accessor('_id', {
      id: '_id',
      header: 'Action',
      cell: (info: any) => (
        <Menu size={'10px'}>
          <MenuButton
            onClick={() => {
              setActiveStatus(info.cell.row.original.isActive);
            }}
          >
            <Text
              marginLeft={2}
              fontSize={21}
              color={'white'}
              cursor={'pointer'}
            >
              ...
            </Text>
          </MenuButton>
          <MenuList bgColor={'#21232E'} borderColor={'#313248'}>
            <MenuItem
              backgroundColor="#21232E"
              _hover={{ backgroundColor: '#41455b' }} // Change colors on hover
              color="#D2D3E0"
              borderRadius="8px"
              px="14px"
              onClick={() => {
                // setSelectedId(info.getValue());
                // dispatch(actions.toggleAdd(true));
                // dispatch(actions.clearFrom());
                handleEdit(info.getValue());
              }}
            >
              Edit User
            </MenuItem>
            <MenuItem
              backgroundColor="#21232E"
              _hover={{ backgroundColor: '#41455b' }} // Change colors on hover
              color="#D2D3E0"
              borderRadius="8px"
              px="14px"
              onClick={() => {
                dispatch(actions.toggleDisableAccountModal(true));
                setSelectedId(info.getValue());
              }}
            >
              {activeStatus == StatusTypeEnum.ACTIVE
                ? 'Mark as Disabled'
                : 'Mark as Enabled'}
            </MenuItem>
            <MenuItem
              backgroundColor="#21232E"
              _hover={{ backgroundColor: '#41455b' }} // Change colors on hover
              color="#D2D3E0"
              borderRadius="8px"
              px="14px"
              onClick={() => {
                dispatch(actions.toggleDeleteAccountModal(true));
                setSelectedId(info.getValue());
              }}
            >
              Delete
            </MenuItem>
          </MenuList>
        </Menu>
      ),
    }),
  ];
  const [sorting, setSorting] = React.useState([]);
  const table = useReactTable({
    data: data,
    columns: columns,
    state: {
      columnFilters,
      globalFilter,
      sorting,
    },
    pageCount: Math.ceil(totalCount / pagesize),
    sortDescFirst: true,
    enableMultiSort: true,
    manualSorting: true,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
  });
  React.useEffect(() => {
    if (sorting.length > 0) {
      dispatch(actions.setSortColumn(sorting[0].id));
      dispatch(actions.setSortDir(sorting[0].desc ? 'desc' : 'asc'));
    }
    return () => {};
  }, [sorting]);
  const createPages = (
    count: number,
    currentPage: number,
    maxButtons: number,
  ) => {
    let arrPageCount: any = [];
    let startPage = Math.max(currentPage - Math.floor(maxButtons / 2), 1);
    let endPage = Math.min(startPage + maxButtons - 1, count);
    startPage = Math.max(endPage - maxButtons + 1, 1);

    for (let i = startPage; i <= endPage; i++) {
      arrPageCount.push(i);
    }

    if (startPage > 1) {
      arrPageCount.unshift('...');
    }
    if (endPage < count) {
      arrPageCount.push('...');
    }

    return arrPageCount;
  };

  // In your component
  const pageCount = table.getPageCount();
  const pages = createPages(pageCount, pageNo, 2);
  React.useEffect(() => {
    if (table.getState().columnFilters[0]?.id === 'name') {
      if (table.getState().sorting[0]?.id !== 'name') {
        table.setSorting([{ id: 'name', desc: false }]);
      }
    }
  }, [table.getState().columnFilters[0]?.id]);
  console.log('Disabled:', pageNo === 1 || data.length === 0);
  const flexDirection: ResponsiveValue<'row' | 'column'> = useBreakpointValue({
    base: 'column',
    md: 'row',
  });
  return (
    <>
      <Flex
        direction="column"
        w="100%"
        overflowX={{ sm: 'scroll', lg: 'hidden' }}
      >
        <Flex align={'center'} justify={'space-between'} w="100%" mb="28px">
          <DebouncedInput
            className="p-2 font-lg shadow border border-block"
            placeholder="Search..."
          />
        </Flex>
        {loading ? (
          <Box justifyContent={'center'} display={'flex'} mx="auto" my={5}>
            <Spinner color="brand.500" />
          </Box>
        ) : (
          <>
            <Box overflowX="auto" mb="24px">
              {table.getRowModel().rows.length > 0 ? (
                <Table variant="simple" color="gray.500" minWidth="600px">
                  <Thead backgroundColor={'#2C2D3C'}>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header: any) => {
                          return (
                            <Th
                              pe="10px"
                              borderColor={borderColor}
                              key={header.id}
                              colSpan={header.colSpan}
                              style={{
                                color: '#D2D3E0',
                                fontWeight: 400,
                                cursor: 'pointer',
                                textTransform: 'capitalize',
                              }}
                              onClick={header.column.getToggleSortingHandler()}
                            >
                              {header.isPlaceholder
                                ? null
                                : flexRender(
                                    header.column.columnDef.header,
                                    header.getContext(),
                                  )}
                            </Th>
                          );
                        })}
                      </Tr>
                    ))}
                  </Thead>
                  <Tbody>
                    {table.getRowModel().rows.map((row: any) => {
                      return (
                        <Tr px="20px" key={row.id}>
                          {row.getVisibleCells().map((cell: any) => {
                            return (
                              <Td
                                key={cell.id}
                                color={textColor}
                                fontSize={{ sm: '12px', md: '14px' }}
                                minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                borderColor={borderColor}
                              >
                                {flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext(),
                                )}
                              </Td>
                            );
                          })}
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              ) : (
                <Text
                  fontSize="sm"
                  color={textColor}
                  fontWeight="normal"
                  textAlign={'center'}
                  marginRight={20}
                >
                  {' '}
                  No Records Available
                </Text>
              )}
            </Box>
            {data.length != 0 && !loading && (
              <Flex
                w="100%"
                direction={flexDirection}
                justify="space-between"
                align={'center'}
                px="20px"
                pt="10px"
                pb="5px"
              >
                <Box>
                  <Stack
                    direction="row"
                    alignSelf="flex-end"
                    alignItems={'center'}
                    spacing="4px"
                    ms="auto"
                  >
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="normal"
                      marginRight={2}
                    >
                      Show
                    </Text>
                    <FormControl
                      style={{
                        marginLeft: 0,
                        backgroundColor: 'transparent',
                      }}
                    >
                      <Select
                        variant="outline"
                        color={textColor}
                        borderWidth={0.5}
                        width={20}
                        height={8}
                        value={pagesize}
                        borderRadius={4}
                        borderColor={'#2C2D3C'}
                        _hover={{
                          cursor: 'pointer',
                        }}
                        _focus={{
                          cursor: 'pointer',
                        }}
                        _active={{
                          cursor: 'pointer',
                        }}
                        focusBorderColor="gray.500"
                        onChange={(e) => {
                          dispatch(actions.setPageNo(1));
                          dispatch(actions.setPageSize(Number(e.target.value)));
                        }}
                        sx={{
                          '> option': {
                            background: '#21232E',
                            color: '#D2D3E0',
                          },
                        }}
                      >
                        {[5, 10, 20, 40, 50, 100, 200].map((data) => (
                          <option style={{ cursor: 'pointer' }}>{data}</option>
                        ))}
                      </Select>
                    </FormControl>
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="normal"
                      marginLeft={2}
                    >
                      entries
                    </Text>
                  </Stack>
                </Box>
                <div className="flex items-center gap-2">
                  <Stack
                    direction="row"
                    alignSelf="flex-end"
                    spacing="4px"
                    ms="auto"
                  >
                    <Button
                      variant="no-effects"
                      onClick={() => {
                        if (pageNo === 1 || data.length === 0) {
                          return;
                        }
                        dispatch(actions.setPageNo(pageNo - 1));
                      }}
                      disabled={pageNo === 1 || data.length === 0}
                      transition="all .5s ease"
                      color={
                        pageNo === 1 || data.length === 0 ? 'gray' : '#D2D3E0'
                      }
                      fontWeight={400}
                      fontSize={14}
                      h="28px"
                      borderRadius="8px"
                      bg="transparent"
                    >
                      <Icon
                        as={MdChevronLeft}
                        w="26px"
                        h="26px"
                        color={'#B99E68'}
                      />
                      Previous
                    </Button>

                    {Array.isArray(pages) &&
                      pages.map((pageNumber, index) => {
                        console.log(pageNumber, index, 'pageNumber');

                        return (
                          <Button
                            variant="no-effects"
                            transition="all .5s ease"
                            onClick={() => {
                              if (pageNumber !== '...') {
                                dispatch(actions.setPageNo(Number(pageNumber)));
                              }
                            }}
                            w="28px"
                            h="28px"
                            minW={'auto'}
                            borderRadius="8px"
                            padding={'6px'}
                            fontWeight={400}
                            bg={
                              pageNumber === pageNo ? brandColor : 'transparent'
                            }
                            key={index}
                          >
                            <Text
                              fontSize="sm"
                              color={pageNumber === pageNo ? '#fff' : textColor}
                            >
                              {pageNumber}
                            </Text>
                          </Button>
                        );
                      })}
                    <Button
                      variant="no-effects"
                      onClick={() => {
                        if (pageNo >= Math.ceil(totalCount / pagesize)) {
                          return;
                        }
                        dispatch(actions.setPageNo(pageNo + 1));
                      }}
                      disabled={pageNo >= Math.ceil(totalCount / pagesize)}
                      transition="all .5s ease"
                      color={
                        pageNo >= Math.ceil(totalCount / pagesize)
                          ? 'gray'
                          : '#D2D3E0'
                      }
                      fontWeight={400}
                      fontSize={14}
                      h="28px"
                      borderRadius="8px"
                      bg="transparent"
                    >
                      Next
                      <Icon
                        as={MdChevronRight}
                        w="26px"
                        h="26px"
                        color={'#B99E68'}
                      />
                    </Button>
                  </Stack>
                </div>

                <Text
                  fontSize="sm"
                  color={textColor}
                  fontWeight="normal"
                  mb={{ sm: '24px', md: '0px' }}
                >
                  Page {pageNo} to{' '}
                  {pageNo > 1
                    ? pageNo * pagesize > totalCount
                      ? totalCount
                      : pageNo * pagesize
                    : pagesize}{' '}
                  of {totalCount}
                </Text>
              </Flex>
            )}
          </>
        )}
      </Flex>
      <Add id={selectedId} open={add} handleClose={handleClose} />
      <ConfirmModal
        id={selectedId}
        title={`${activeStatus == 1 ? 'Disable' : 'Enable'} Account`}
        open={disableModal}
        buttonTitle={activeStatus == 1 ? 'Disable' : 'Enable'}
        content={`Do you want to ${
          activeStatus == 1 ? 'Disable' : 'Enable'
        } this account ?`}
        handleClose={handleCloseDisableModal}
        handleClick={handleDisable}
      />
      <ConfirmModal
        id={selectedId}
        title={'Delete Account'}
        open={deleteModal}
        buttonTitle={'Delete'}
        content={'Do you want to delete this account ?'}
        handleClose={handleCloseDeleteModal}
        handleClick={handleDelete}
      />
    </>
  );
}
// A debounced input react component
function DebouncedInput({
  debounce = 500,
}: {
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const dispatch = useDispatch();
  const search = useSelector(selectSearch);
  const handleAdd = () => {
    dispatch(actions.setSearch(''));
    dispatch(actions.toggleAdd(true));
  };
  React.useEffect(() => {
    if (search.length > 0) {
      dispatch(actions.setPageNo(1));
    }
    return () => {};
  }, [search]);
  const handleChange = (e: any) => {
    dispatch(actions.setSearch(e.target.value));
  };
  return (
    <>
      <SearchBar
        value={search}
        handleChange={handleChange}
        h="36px"
        w={{ sm: '190px', lg: '280px' }}
        borderRadius="4px"
        background="#21232E"
      />
      <Button
        size="md"
        fontSize="sm"
        variant="brand"
        fontWeight="400"
        w="104px"
        leftIcon={<AddIcon width={3} height={3} color={'#EEEFFC'} />}
        onClick={handleAdd}
        isLoading={undefined}
        isDisabled={undefined}
      >
        Add User
      </Button>
    </>
  );
}
const avatarStyle = {
  height: 8,
  width: 8,
  marginRight: '4px',
  backgroundColor: '#009BA5',
  fontSize: 8,
  fontWeight: 500,
};
